module.exports = __webpack_public_path__ + "media/images/search-icon-111dbfe75de46a40166b1de9adad4618.svg";